'use strict';

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function BrandFandomLogomark(props) {
    return (React__namespace.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 174 242", width: "1em", height: "1em" }, props),
        React__namespace.createElement("path", { fill: "#FA005A", d: "M166.935 118.154L50.108 1.273A4.317 4.317 0 0045.405.34a4.314 4.314 0 00-2.662 3.99v98.276L7.365 67.22a4.31 4.31 0 00-4.702-.933A4.312 4.312 0 000 70.277v101.487a24.1 24.1 0 007.07 17.072l46.037 46.099a24.17 24.17 0 0017.068 7.085h33.68a24.14 24.14 0 0017.063-7.075l46.027-46.099A24.133 24.133 0 00174 171.774v-36.533a24.148 24.148 0 00-1.834-9.247 24.137 24.137 0 00-5.231-7.84z" }),
        React__namespace.createElement("path", { fill: "#FFC500", d: "M131.297 160.901a7.24 7.24 0 01-2.108 5.111l-37.11 37.3a7.231 7.231 0 01-7.914 1.582 7.246 7.246 0 01-2.355-1.582l-36.99-37.3a7.221 7.221 0 01-2.117-5.096v-14.191a7.234 7.234 0 012.128-5.116l13.317-13.328a7.225 7.225 0 0110.245 0l18.624 18.645 18.596-18.65a7.22 7.22 0 015.122-2.127 7.228 7.228 0 015.121 2.127l13.318 13.328a7.218 7.218 0 012.123 5.116v14.181z" })));
}

module.exports = BrandFandomLogomark;
